import { ComponentInfo } from "@builder.io/sdk-react";

import { highlightCardInputs } from "../HighlightCard/HighlightCard.builder";

export const CATEGORY_ITEMS_INPUTS = [
  {
    name: "items",
    type: "list",
    subFields: [
      {
        name: "name",
        type: "string",
        defaultValue: "",
      },
      {
        name: "url_key",
        type: "string",
        defaultValue: "",
      },
      {
        name: "sku",
        type: "string",
        defaultValue: "ploom",
      },
      {
        name: "shortDescription",
        type: "string",
      },
      {
        name: "isNew",
        type: "boolean",
      },
      {
        name: "thumbnailSrc",
        type: "string",
        defaultValue: "",
        required: false,
      },
      {
        name: "categoryUrlKey",
        type: "string",
      },
      {
        name: "badge",
        type: "object",
        subFields: [
          { name: "left", type: "string" },
          { name: "right", type: "string" },
        ],
      },
    ],
    defaultValue: [],
  },
  {
    name: "columnDesktopWidth",
    type: "string",
    enum: ["3", "4", "6", "12"],
    defaultValue: "4",
    required: true,
  },
  {
    name: "columnTabletWidth",
    type: "string",
    enum: ["3", "4", "6", "12"],
  },
  {
    name: "withRtbCard",
    type: "boolean",
    required: true,
    defaultValue: false,
  },
  {
    name: "rtbCard",
    type: "object",
    showIf: "options.get('withRtbCard') === true",
    subFields: [
      ...highlightCardInputs,
      {
        name: "specification",
        type: "string",
      },
    ],
    defaultValue: {
      imageUrl:
        "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F035813b7aeb845139d31942675bcbb18",
      alt: "Highlight image",
      buttonText: "Learn more",
      title: "Highlight title",
      description:
        "Nunc varius nisl felis. Donec fermentum, lorem at scelerisque",
      buttonUrl: "/",
      theme: "dark",
    },
  },
] as const satisfies ComponentInfo["inputs"];

export type CategoryItemsProps = BuilderComponentProps<
  typeof CATEGORY_ITEMS_INPUTS
>;
